import { observer } from 'mobx-react-lite'
import { t } from '@lingui/core/macro'

import type { PhotosApi } from '@jotta/types/PhotosApi'
import { CollectionType } from '@jotta/types/schemas/AlbumSchema'

import { BaseAlbumThumb } from '../AlbumThumb/BaseAlbumThumb'

export interface MoreAlbumsThumbProps {
  albums: PhotosApi.AlbumInfo[]
  sectionType: CollectionType
}

export const MoreAlbumsThumb = observer<MoreAlbumsThumbProps>(
  function MoreAlbumsThumb({ albums, sectionType }) {
    const texts: Record<CollectionType, string> = {
      [CollectionType.NORMAL_ALBUM]: t`View all your albums`,
      [CollectionType.LOCATION_ALBUM]: t`View all locations`,
      [CollectionType.META_SHARED_ALBUM_TYPES]: t`View all shared`,
      [CollectionType.SHARED_PHOTOS]: t`View all shared`,
    }

    return (
      <BaseAlbumThumb title={texts[sectionType]}>
        <div className="grid h-full grid-cols-2 gap-0">
          {albums
            .slice(0, 4)
            .map(
              album =>
                album.coverPhoto?.thumbnail_url && (
                  <img
                    key={album.id}
                    className="block size-full object-cover"
                    draggable={false}
                    src={`${album.coverPhoto.thumbnail_url}.s`}
                    alt={`${album?.title || 'Album'}`}
                  />
                ),
            )}
        </div>
        <div className="absolute inset-0 flex items-center justify-center bg-surface-container opacity-80">
          <span className="font-heading text-2xl leading-[1.125] text-on-surface-variant">{`+${albums.length}`}</span>
        </div>
      </BaseAlbumThumb>
    )
  },
)
